export const channels = [
    {
        label: 'Web',
        value: 'WEB'
    },
    {
        label: 'Chatbot',
        value: 'CHATBOT'
    }
]